import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/components/ui/utils';

export function NavMenuTooltip({
  label,
  subtitle,
  children,
  disabled,
  side = 'right',
}: {
  label: string;
  subtitle?: string;
  children: ReactNode;
  disabled?: boolean;
  side?: 'right' | 'top' | 'bottom' | 'left';
}) {
  if (disabled) return <>{children}</>;

  return (
    <Tooltip delayDuration={280}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={14}
        className={cn(
          'relative max-w-[min(18rem,calc(100vw-6rem))] rounded-xl border border-sidebar-primary/30',
          'bg-gradient-to-br from-sidebar-primary via-[#d4849a] to-sidebar-primary/90',
          'px-3.5 py-2.5 text-sidebar-primary-foreground shadow-xl shadow-black/20',
          'animate-in fade-in-0 zoom-in-95 [&>svg]:hidden',
        )}
      >
        <span
          className="absolute left-0 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 bg-sidebar-primary"
          aria-hidden
        />
        <p className="text-sm font-semibold leading-snug">{label}</p>
        {subtitle ? <p className="mt-1 text-xs leading-snug opacity-80">{subtitle}</p> : null}
      </TooltipContent>
    </Tooltip>
  );
}

